export const IMAGES = {
  ICON_RELOAD: `${process.env.PUBLIC_URL}/img/icon_reload.png`,
  SAVVY_ICON: `${process.env.PUBLIC_URL}/img/s-logo.png`,
  MERCHANT_DUMMY: `${process.env.PUBLIC_URL}/img/caratlane.png`,
  LOGO: `${process.env.PUBLIC_URL}/img/logo.png`,
  LOGO_DARK: `${process.env.PUBLIC_URL}/img/logo-dark.png`,
  MOTILAL_OSWAL: 'https://groww.in/images/partners/motilal_groww.svg',
};
